export const PRIVATE_ROUTES = {
  PRIVATE: "private",
  DASHBOARD: "dashboard",
  HOME: "home",
  LOGS: "logs",
  LOGS_DETAIL: "logs/detail",
};

export const PUBLIC_ROUTES = {
  HOME: "/",
};

export const NAME_BADGES: {
  [key: string]: string;
} = {
  acciones: "FIELD_ACTION",
  connection: "CONNECTION",
  aws: "AWS",
  logs: "LOGS",
  form: "FORM",
};

export const BADGE_COLORS: {
  [key: string]: string;
} = {
  AWS: "#FF9900",
  LOGS: "#00C29C",
  FIELD_ACTION: "#32C1FF",
  CONNECTION: "#F5B7B1",
  FORM: "#ff5f08",
};


export const TOOLTIP_TITLES = {
  cardId: "Ingresa el card ID de la tarjeta que deseas evaluar",
};